import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M11 25.1344V22.8652H36.9999V25.1344H11Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map